module.exports = __webpack_public_path__ + "img/yes.53156e54.png";